import React, {
  useState,
} from "react";

import axios from "axios";

import {
  API_BASE_URL,
} from "../config/apiBase";

import {
  useNavigate,
} from "react-router-dom";


// ============================================================
// ADMIN LOGIN
// ============================================================

export default function AdminLogin() {
  const navigate =
    useNavigate();

  const [
    username,
    setUsername,
  ] =
    useState("admin");

  const [
    password,
    setPassword,
  ] =
    useState("");

  const [
    error,
    setError,
  ] =
    useState("");

  const [
    loading,
    setLoading,
  ] =
    useState(false);


  // ==========================================================
  // LOGIN
  // ==========================================================

  const login =
    async () => {
      setError("");

      // -------------------------------------------------------
      // VALIDATION
      // -------------------------------------------------------

      if (!username.trim()) {
        setError(
          "Username is required"
        );

        return;
      }

      if (!password.trim()) {
        setError(
          "Password is required"
        );

        return;
      }

      try {
        setLoading(true);

        const url =
          `${API_BASE_URL}/api/admin/login`;

        console.log(
          "[Admin Login] API URL:",
          url
        );

        const res =
          await axios.post(
            url,
            {
              username:
                username.trim(),

              password,
            },
            {
              headers: {
                "Content-Type":
                  "application/json",

                Accept:
                  "application/json",
              },

              timeout:
                30000,
            }
          );

        // -----------------------------------------------------
        // TOKEN REQUIRED
        // -----------------------------------------------------

        if (!res.data?.token) {
          setError(
            "No authentication token was received from the server."
          );

          return;
        }

        // -----------------------------------------------------
        // SAVE TOKEN
        // -----------------------------------------------------

        localStorage.setItem(
          "adminToken",
          res.data.token
        );

        // -----------------------------------------------------
        // SUCCESS
        // -----------------------------------------------------

        navigate(
          "/adminpremiumlist",
          {
            replace: true,
          }
        );
      }
      catch (err) {
        console.error(
          "[Admin Login] Error:",
          err
        );

        // =====================================================
        // SERVER RESPONDED
        // =====================================================

        if (err.response) {
          console.error(
            "[Admin Login] Status:",
            err.response.status
          );

          console.error(
            "[Admin Login] Response:",
            err.response.data
          );

          if (
            err.response.status === 401
          ) {
            setError(
              "Invalid username or password."
            );

            return;
          }

          if (
            err.response.status === 403
          ) {
            setError(
              "Admin access is not allowed."
            );

            return;
          }

          const serverMessage =
            err.response?.data?.message ||
            err.response?.data?.detail ||
            err.response?.data?.title;

          setError(
            serverMessage ||
            `Admin login failed. Server returned ${err.response.status}.`
          );

          return;
        }

        // =====================================================
        // NETWORK ERROR
        // =====================================================

        if (err.request) {
          setError(
            "Unable to connect to the Reignite Spirit API."
          );

          return;
        }

        // =====================================================
        // OTHER ERROR
        // =====================================================

        setError(
          err.message ||
          "Admin login failed."
        );
      }
      finally {
        setLoading(false);
      }
    };


  // ==========================================================
  // UI
  // ==========================================================

  return (
    <div
      className="
        flex
        flex-col
        items-center
        justify-center
        min-h-screen
        bg-[#0A0014]
        text-white
      "
    >
      <h1
        className="
          text-3xl
          mb-6
        "
      >
        Admin Login
      </h1>

      {error && (
        <p
          className="
            text-red-400
            mb-3
            text-center
          "
        >
          {error}
        </p>
      )}

      <input
        type="text"
        placeholder="Username"
        className="
          mb-3
          p-3
          rounded
          bg-[#1b0b2e]
        "
        value={username}
        onChange={(e) =>
          setUsername(
            e.target.value
          )
        }
      />

      <input
        type="password"
        placeholder="Password"
        className="
          mb-4
          p-3
          rounded
          bg-[#1b0b2e]
        "
        value={password}
        onChange={(e) =>
          setPassword(
            e.target.value
          )
        }
        onKeyDown={(e) => {
          if (
            e.key === "Enter"
          ) {
            login();
          }
        }}
      />

      <button
        type="button"
        onClick={login}
        disabled={loading}
        className="
          px-6
          py-3
          bg-gradient-to-r
          from-purple-500
          to-pink-500
          rounded
          text-white
          font-semibold
          disabled:opacity-60
        "
      >
        {
          loading
            ? "Logging in..."
            : "Login"
        }
      </button>
    </div>
  );
}